// src/pages/DisclaimerPage.tsx
import React, {useEffect} from "react";
import styled from "styled-components";
import {useSingleton} from "cms/factory";
import {DocumentRenderer, DocumentRendererProps} from "@keystone-6/document-renderer";
import {SFText18W400, SText24W700, SText40W700,} from "../Typography";
import ContentLayout from "../ContentLayout";

type CmsSystem = {
    id: string;
    footerDisclaimer?: { document: { content: any } } | null;
};

const SYS_SEL = `
  id
  footerDisclaimer { document }
`;

const Disclaimer: React.FC = () => {
    const {data: system} = useSingleton<CmsSystem>("System", SYS_SEL);

    useEffect(() => {
        document.title = "Disclaimer";
    }, []);

    return (
        <Wrap backTo="/">
            {system?.footerDisclaimer && (
                <DocumentRenderer
                    document={
                        system.footerDisclaimer?.document as unknown as DocumentRendererProps["document"]
                    }
                    renderers={{
                        block: {
                            heading: ({level, children}) => {
                                if (level === 1) return <Title as="h1">{children}</Title>;
                                if (level === 2) return <SubTitle as="h2">{children}</SubTitle>;
                                if (level === 3) return <SubSubTitle as="h3">{children}</SubSubTitle>;
                                return <p>{children}</p>;
                            },
                            paragraph: ({children}) => <Paragraph>{children}</Paragraph>,
                        },
                        inline: {
                            link: ({children, href}) => (
                                <a
                                    href={href}
                                    style={{color: "#16a34a", textDecoration: "underline"}}
                                >
                                    {children}
                                </a>
                            ),
                        },
                    }}
                />
            )}
        </Wrap>
    );
};

export default Disclaimer;

/* ================= styles ================= */

const Wrap = styled(ContentLayout)`
    text-align: left;
`;

const Title = styled(SText40W700)`
    margin-bottom: 24px;
    text-align: left;
`;

const SubTitle = styled(SText24W700)`
    margin: 24px 0 16px;
    text-align: left;
`;

const SubSubTitle = styled(SFText18W400)`
    margin: 16px 0 12px;
    font-weight: 700;
    text-align: left;
`;

const Paragraph = styled.p`
    font-family: "GTAmerica", sans-serif;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    margin: 0 0 16px;
    @media (max-width: 768px) {
        font-size: 16px;
        line-height: 20px;
    }
`;
